'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$UploadFileResponse(origin, text) {
  this.WN = null;
  this.WO = null;
  this.WN = origin;
  this.WO = text;
}
export { $c_Lpresto_AgentView$UploadFileResponse as $c_Lpresto_AgentView$UploadFileResponse };
$p = $c_Lpresto_AgentView$UploadFileResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$UploadFileResponse;
/** @constructor */
function $h_Lpresto_AgentView$UploadFileResponse() {
}
export { $h_Lpresto_AgentView$UploadFileResponse as $h_Lpresto_AgentView$UploadFileResponse };
$h_Lpresto_AgentView$UploadFileResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$UploadFileResponse) && ((this.WN === x$0.WN) && (this.WO === x$0.WO))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "UploadFileResponse";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.WN;
  }
  if ((n === 1)) {
    return this.WO;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AgentView$UploadFileResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hM)));
}
export { $isArrayOf_Lpresto_AgentView$UploadFileResponse as $isArrayOf_Lpresto_AgentView$UploadFileResponse };
var $d_Lpresto_AgentView$UploadFileResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$UploadFileResponse, "presto.AgentView$UploadFileResponse", ({
  hM: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$UploadFileResponse as $d_Lpresto_AgentView$UploadFileResponse };
//# sourceMappingURL=presto.-Agent-View$-Upload-File-Response.js.map
